import { ROLES } from '@/constants/roles';
import { PERMISSIONS as P, WILDCARD } from './permissions';

// Role → permission[] matrix (PERMISSION_MATRIX.md). super_admin holds the wildcard.
export const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: [WILDCARD],

  [ROLES.ADMIN]: [
    P.DASHBOARD_READ,
    P.USERS_READ, P.USERS_WRITE, P.USERS_DELETE, P.USERS_BLOCK, P.USERS_GRANT_PRO, P.USERS_EXPORT,
    P.CONTENT_READ, P.CONTENT_WRITE, P.CONTENT_DELETE, P.CONTENT_PUBLISH, P.CONTENT_ENRICH, P.CONTENT_EXPORT,
    P.SCRAPER_READ, P.SCRAPER_RUN,
    P.QUIZ_READ, P.QUIZ_WRITE, P.QUIZ_DELETE, P.QUIZ_GENERATE,
    P.MAINS_READ, P.MAINS_WRITE, P.MAINS_DELETE,
    P.AI_READ, P.AI_MODERATE, P.AI_SETTINGS,
    P.CATEGORIES_READ, P.CATEGORIES_WRITE, P.CATEGORIES_DELETE,
    P.EXAMS_READ, P.EXAMS_WRITE, P.EXAMS_DELETE,
    P.ALERTS_READ, P.ALERTS_WRITE, P.ALERTS_DELETE,
    P.DOWNLOADS_READ, P.DOWNLOADS_WRITE, P.DOWNLOADS_DELETE,
    P.PAYMENTS_READ, P.PAYMENTS_REFUND, P.PAYMENTS_RECONCILE, P.PAYMENTS_EXPORT,
    P.SUBSCRIPTIONS_GRANT, P.SUBSCRIPTIONS_REVOKE,
    P.COUPONS_READ, P.COUPONS_WRITE, P.COUPONS_DELETE,
    P.NOTIFICATIONS_READ, P.NOTIFICATIONS_SEND,
    P.SETTINGS_READ, P.AUDIT_READ,
  ],

  [ROLES.MANAGER]: [
    P.DASHBOARD_READ,
    P.CONTENT_READ, P.CONTENT_WRITE, P.CONTENT_DELETE, P.CONTENT_PUBLISH, P.CONTENT_ENRICH, P.CONTENT_EXPORT,
    P.SCRAPER_READ, P.SCRAPER_RUN,
    P.QUIZ_READ, P.QUIZ_WRITE, P.QUIZ_DELETE, P.QUIZ_GENERATE,
    P.MAINS_READ, P.MAINS_WRITE, P.MAINS_DELETE,
    P.AI_READ,
    P.CATEGORIES_READ, P.CATEGORIES_WRITE, P.CATEGORIES_DELETE,
    P.EXAMS_READ, P.EXAMS_WRITE,
    P.ALERTS_READ, P.ALERTS_WRITE, P.ALERTS_DELETE,
    P.DOWNLOADS_READ, P.DOWNLOADS_WRITE, P.DOWNLOADS_DELETE,
    P.NOTIFICATIONS_READ, P.NOTIFICATIONS_SEND,
  ],

  [ROLES.SUPPORT]: [
    P.DASHBOARD_READ,
    P.USERS_READ, P.USERS_BLOCK, P.USERS_EXPORT,
    P.CONTENT_READ, P.CONTENT_EXPORT,
    P.QUIZ_READ, P.MAINS_READ, P.AI_READ,
    P.CATEGORIES_READ, P.EXAMS_READ, P.ALERTS_READ, P.DOWNLOADS_READ,
    P.PAYMENTS_READ, P.PAYMENTS_RECONCILE, P.PAYMENTS_EXPORT,
    P.COUPONS_READ,
    P.NOTIFICATIONS_READ,
  ],

  [ROLES.MODERATOR]: [
    P.DASHBOARD_READ,
    P.CONTENT_READ, P.CONTENT_PUBLISH, P.CONTENT_EXPORT,
    P.QUIZ_READ,
    P.MAINS_READ, P.MAINS_WRITE,
    P.AI_READ, P.AI_MODERATE,
    P.CATEGORIES_READ, P.EXAMS_READ, P.ALERTS_READ, P.DOWNLOADS_READ,
  ],
};

// Resolve the effective permission list for a role (falls back to []).
export const permissionsForRole = (role) => ROLE_PERMISSIONS[role] || [];

// Does a permission list satisfy a required permission? (wildcard wins)
export const listHas = (list = [], permission) =>
  list.includes(WILDCARD) || list.includes(permission);
